import SettingsContent from '../Wrapper';
import Automation from './Index';
import { frontendURL } from '../../../../helper/URLHelper';
import {requireAuth} from "../../dashboard.routes";
import {FEATURE_FLAGS} from "../../../../featureFlags";

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/automation'),
      component: SettingsContent,
      props: {
        headerTitle: 'AUTOMATION.HEADER',
        icon: 'automation',
        showNewButton: false,
      },
      children: [
        {
          path: '',
          name: 'automation_wrapper',
          redirect: 'list',
          meta: {
            permissions: ['administrator'],
          },
        },
        {
          path: 'list',
          name: 'automation_list',
          component: Automation,
          roles: ['administrator'],
          beforeEnter: requireAuth,
          meta: {
            permission: FEATURE_FLAGS.AUTOMATIONS,
            permissions: ['administrator'],
          }
        },
      ],
    },
  ],
};
